import "common/utils/Polyfill/String/String";
import { Buffer } from "buffer";
import { createRoot } from "react-dom/client";
import Providers from "ui/Providers";
import Router from "ui/router/Router";
import "ui/locale/i18n";

window.Buffer = Buffer;

const container = document.getElementById("root");
// skipcq: JS-0339
const root = createRoot(container!);
root.render(
    <Providers>
        <Router />
    </Providers>,
);
